import React from 'react';
import { Overlay } from '~/ui/overlay/Overlay';
import useWindowSize from 'react-use/lib/useWindowSize';
import Confetti from 'react-confetti';
import styled from 'styled-components';
import { Button } from '~/ui/buttons';
import llamaImage from './llama.png';

const Llama = styled.div`
  background-image: url(${llamaImage});
  width: 192px;
  height: 224px;
  margin-left: auto;
  margin-right: auto;
`;

const Container = styled.div`
  z-index: 9999;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Popup = styled.div`
  background-color: #fff;
  width: 314px;
  height: 442px;
  border-radius: 16px;
  padding: 24px;
  position: relative;
  margin: 100px auto;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  z-index: 9999;

  h2 {
    text-align: center;
  }

  button {
    font-family: ralewayBold;
  }
`;

export const CourseCreated = ({ onClose }: { onClose: () => void }) => {
  const { width, height } = useWindowSize();
  return (
    <Container>
      <Overlay open={true}>
        <Confetti width={width} height={height} />
        <Popup>
          <h2>A Course Has Been Successfully Created!</h2>
          <Llama />
          <Button onClick={onClose}>Review & Edit</Button>
        </Popup>
      </Overlay>
    </Container>
  );
};
